import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    target;
    avatarUrl;
    remoteURL;
    required;
    imageUrl = '';
    handleCreate() {
        this.$router.push('/users/account/create');
    }
    uploadFile1() {
        const _this = this;
        const fileInput = document.createElement('input');
        fileInput.setAttribute('type', 'file');
        fileInput.addEventListener('change', function (e) {
            console.log('e', fileInput.files[0]);
            const uploadedFile = fileInput.files[0];
            const name = uploadedFile.name;
            const size = uploadedFile.size;
            _this.$elmessage({
                message: `${_this.$t('upload')} ${name} ${size}`,
                type: 'success',
            });
        });
        fileInput.click();
    }
    handleFullScreen() {
        this.$emit('onFullScreen');
    }
    handleRefresh() {
        this.$emit('onRefresh');
    }
    handleAvatarSuccess() { }
    async beforeAvatarUpload($e) {
        this.target = $e.target;
        const avatarItem = $e.target.files[0];
        console.log('avatarItem:', avatarItem);
        if ((avatarItem.type !== 'image/png' && avatarItem.type !== 'image/jpeg') || avatarItem.size > 1024 * 1024) {
            this.$elmessage(this.$t('uploadFormat').toString());
            this.target.value = '';
            return;
        }
        const convert_base64 = await this.getBase64(avatarItem);
        this.target.value = '';
        if (!convert_base64) {
            this.$elmessage.error(this.$t('uploade').toString());
            return;
        }
        this.imageUrl = convert_base64;
        // this.$emit('onAvatar', this.imageUrl.substring(22));
        this.$emit('onAvatar', this.imageUrl);
    }
    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                // console.log('file:', reader.result);
                resolve(reader.result);
            };
            reader.onerror = () => {
                resolve(false);
            };
        });
    }
    onavatarUrlChange(newVal) {
        if (!newVal) {
            this.imageUrl = '';
        }
        else {
            this.imageUrl = newVal;
        }
    }
    onRemoteURLChange() {
        if (this.remoteURL) {
            this.imageUrl = this.remoteURL;
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "avatarUrl", void 0);
__decorate([
    Prop()
], default_1.prototype, "remoteURL", void 0);
__decorate([
    Prop()
], default_1.prototype, "required", void 0);
__decorate([
    Watch('avatarUrl', { immediate: true })
], default_1.prototype, "onavatarUrlChange", null);
__decorate([
    Watch('remoteURL', { immediate: true })
], default_1.prototype, "onRemoteURLChange", null);
default_1 = __decorate([
    Component({
        name: 'AccountTableHeader',
        i18n: {
            messages: {
                'en-us': {
                    accountList: 'Account List',
                    exportCsv: 'Export Excel',
                    create: 'Create',
                    clickUpload: 'Click to upload',
                    uploadFormat: 'Please upload .png or .jpeg file, file size need to be less than 1mb',
                    uploade: 'Upload Error',
                    upload: 'Successfully Upload',
                },
                zh: {
                    accountList: '账户列表',
                    exportCsv: '导出Excel',
                    create: '创建账户',
                    clickUpload: '点击上传',
                    uploadFormat: '请使用.png或.jpeg文件, 文件大小小于1mb',
                    uploade: '上传错误',
                    upload: '成功上传',
                },
            },
        },
    })
], default_1);
export default default_1;
